import Image from 'next/image';
import { useState } from 'react';
import { FreeMode, Keyboard, Mousewheel, Navigation, Thumbs } from 'swiper';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';
import { Swiper, SwiperSlide } from 'swiper/react';
import styles from './SlideGallery.module.css';

export default function SlideGallery(props) {
   const { slides } = props;
   const [galleryThumbs, setGalleryThumbs] = useState(null);
   const imageClass = props.className;

   if (!slides || slides.length === 0 || !Array.isArray(slides)) {
      return null;
   }
   return (
      <>
         <Swiper
            style={{ width: '100%', height: 'auto', maxWidth: '100%' }}
            spaceBetween={50}
            slidesPerView={1}
            keyboard={true}
            navigation={true}
            thumbs={{ swiper: galleryThumbs && !galleryThumbs.destroyed ? galleryThumbs : undefined }}
            modules={[FreeMode, Navigation, Thumbs, Keyboard]}
         >
            {slides.map((slide, i) => (
               <SwiperSlide key={slide} className={styles.slide}>
                  <Image
                     priority={true}
                     src={slide}
                     alt={'slide' + i}
                     width={455}
                     height={255}
                     style={{ width: '100%', height: 'auto' }}
                     {...(imageClass && { className: imageClass })}
                  />
               </SwiperSlide>
            ))}
         </Swiper>
         <Swiper
            onSwiper={(swiper) => setGalleryThumbs(swiper)}
            spaceBetween={10}
            slidesPerView={4}
            watchSlidesProgress={true}
            freeMode={true}
            mousewheel={true}
            modules={[FreeMode, Navigation, Thumbs, Mousewheel]}
            className={styles.thumbs}
         >
            {slides.map((slide, i) => (
               <SwiperSlide key={slide}>
                  <Image src={slide} alt={'slide' + i} width={455} height={255} key={i} />
               </SwiperSlide>
            ))}
         </Swiper>
      </>
   );
}
